import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import {
  heroSquares2x2,
  heroCube,
  heroClipboardDocumentList,
  heroUsers,
  heroCog6Tooth,
} from '@ng-icons/heroicons/outline';

interface NavItem {
  label: string;
  route: string;
  icon: string;
}

@Component({
  selector: 'app-sidebar',
  imports: [RouterLink, RouterLinkActive, NgIcon],
  host: { class: 'block h-full' },
  providers: [
    provideIcons({
      heroSquares2x2,
      heroCube,
      heroClipboardDocumentList,
      heroUsers,
      heroCog6Tooth,
    }),
  ],
  template: `
    <div class="flex flex-col h-full bg-base-200">

      <!-- Logo -->
      <div class="px-6 py-5 border-b border-base-300">
        <img src="logo.png" alt="Prezzemolo & Vitale" class="w-40" />
      </div>

      <!-- Menu -->
      <ul class="menu menu-md w-full flex-1 px-3 py-4 gap-1">
        @for (item of navItems; track item.route) {
          <li class="w-full">
            <a
              [routerLink]="item.route"
              routerLinkActive="active"
              class="w-full flex items-center gap-3"
            >
              <ng-icon [name]="item.icon" size="20" />
              {{ item.label }}
            </a>
          </li>
        }
      </ul>

      <!-- Footer sidebar -->
      <div class="px-4 py-3 border-t border-base-300 text-xs text-base-content/40 text-center">
        Prezzemolo &amp; Vitale &copy; {{ year }}
      </div>

    </div>
  `,
  styles: ``
})
export class SidebarComponent {
  year = new Date().getFullYear();

  navItems: NavItem[] = [
    // { label: 'Dashboard',  route: '/home/dashboard', icon: 'heroSquares2x2' },
    // { label: 'Utenti',    route: '/home/users', icon: 'heroUsers' },
    // { label: 'Impostazioni', route: '/home/settings', icon: 'heroCog6Tooth' },
    { label: 'Esporta', route: '/home/ts_export', icon: 'heroCube' },
    { label: 'Log Esportazioni', route: '/home/exports', icon: 'heroClipboardDocumentList' },
  ];
}
